export const LIKE_TREE_ACTIONS_TYPES = {
  FETCH_MOVIE_DATA_ACTION: "FETCH_MOVIE_DATA_ACTION",
  FETCH_RECOMMENDATIONS_ACTION: "FETCH_RECOMMENDATIONS_ACTION",
  FETCH_RANDOM_MOVIE_IDS: "FETCH_RANDOM_MOVIE_IDS",
};
